/**
 * SCORM format types for workflow export
 */
export const SCORM_FORMAT_TYPES = {
  MULTI_SCO: "multi-sco",
  SINGLE_SCO: "single-sco",
};
